import { HomeScreen } from '@strata/react-page-templates';

import { AppRoutes } from 'services/routes';
import { useGetHomeScreenMessagesQuery } from 'store/api/announcementApi';

export const Home = () => {
    const { data: messages } = useGetHomeScreenMessagesQuery();

    return (
        <HomeScreen
            illustration={HomeScreen.Illustration.COMPASS}
            button={{ label: 'View Requests', path: AppRoutes.requests }}
            welcomeMessagePartOne="With Free Market Health's Compass application, you have the ability to guide and improve a Payer's experience by managing member inquiries and fulfilling change management requests."
            messages={messages}
            viewAllUpdatesUrl={AppRoutes.updatesHistory}
        />
    );
};
